/**
 * Choose Your Ritual Controller (choose-your-ritual.js)
 * Reveals cards with a staggered fade-up as the section enters the viewport,
 * using IntersectionObserver + CSS transitions (no animation library required).
 */

(function () {
  function initSection(section) {
    if (section.dataset.cyrInitialized === 'true') return;
    section.dataset.cyrInitialized = 'true';

    const cards = section.querySelectorAll('.cyr-card-item');
    cards.forEach((card, index) => {
      card.style.setProperty('--cyr-delay', `${index * 0.15}s`);
    });

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
      section.classList.add('cyr-in-view');
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.classList.add('cyr-in-view');
            obs.disconnect();
          }
        });
      },
      { threshold: 0.15 }
    );

    observer.observe(section);
    section._cyrObserver = observer;
  }

  function destroySection(section) {
    if (section._cyrObserver) {
      section._cyrObserver.disconnect();
      delete section._cyrObserver;
    }
  }

  function initAll() {
    document.querySelectorAll('.cyr-section').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.cyr-section');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.cyr-section');
    if (section) destroySection(section);
  });
})();
